<add-operator-vehicle *ngIf="visibleAddOperatorVehicle"
                      [menuPermissionActive]="menuPermissionActive"
                      (changedOpenAddOperatorVehicleEmit)="changedOpenAddOperatorVehicleEmit($event)" />

<operator-vehicle-detail *ngIf="visibleVehicleDetail"
                         [vehicleId]="selectVehicleId"
                         (changedAddOperatorVehicleDetailEmit)="changedAddOperatorVehicleDetailEmit($event)" />

<add-drivers-to-vehicle-dialog *ngIf="visibleAddDriversToVhicle"
                               [_visibleAddDriversToVhicle]="visibleAddDriversToVhicle"
                               [_vehicleId]="selectVehicleId"
                               (changedVisibleAddDriversToVhicleEmit)="changedVisibleAddDriversToVhicleEmit($event)" />

<xp-loading *ngIf="isLoading" class="card flex justify-content-center" [diameter]="48"></xp-loading>

<div *ngIf="!isLoading && !visibleAddOperatorVehicle && !visibleVehicleDetail"
     class="flex flex-column operator-vehicles-block">
    <xp-page-header class="operator-vehicles-block__title mb-3" heading="Vehicles"></xp-page-header>

    <mat-tab-group class="vehicle-tab-group mb-3"
                   [selectedIndex]="menuVehicleActive"
                   (selectedIndexChange)="handleTabChange($event)">
        <mat-tab label="Active Vehicles"></mat-tab>
        <mat-tab label="Inactive Vehicles"></mat-tab>
    </mat-tab-group>

    <div class="flex flex-row flex-wrap vehicle-cards-row">
        <mat-card class="operator-vehicle-block mr-3 mt-3" *ngFor="let vehicle of operatorVehicles">
            <xp-badge class="vehicle-status-banner"
                      [ngClass]="{
                        'vehicle-status-banner--pending': getApprovalStatus(vehicle) === 'Pending',
                        'vehicle-status-banner--approved': getApprovalStatus(vehicle) === 'Approved',
                        'vehicle-status-banner--rejected': getApprovalStatus(vehicle) === 'Rejected'
                      }"
                      [icon]="getApprovalStatus(vehicle) === 'Approved' ? 'check_circle' : null"
                      [iconSrc]="getApprovalStatusIconSrc(vehicle)">{{ getApprovalStatusLabel(vehicle) }}</xp-badge>

            <div class="operator-vehicle-block__vehicle-name">
                {{vehicle.VehicleBrandName}} {{vehicle.VehicleModelName}} {{vehicle.NumberPlate}}
            </div>

            <div class="operator-vehicle-block__vehicle-img" *ngIf="vehicle.VehicleFrontImageUrl">
                <img [src]="vehicle.VehicleFrontImageUrl" alt="" />
            </div>

            <div class="operator-vehicle-block__vehicle-info">
                <xp-info-row class="vehicle-info-row" label="Vehicle Type">{{vehicle.VehicleTypeText}}</xp-info-row>
                <xp-info-row class="vehicle-info-row" label="Vehicle Make">{{vehicle.VehicleBrandName}}</xp-info-row>
                <xp-info-row class="vehicle-info-row" label="Vehicle Model">{{vehicle.VehicleModelName}}</xp-info-row>
                <xp-info-row class="vehicle-info-row" label="Plate No.">{{vehicle.NumberPlate}}</xp-info-row>
                <xp-info-row class="vehicle-info-row" label="Boundary Fee">₱{{vehicle.BoundaryAmount}}</xp-info-row>
                <xp-info-row class="vehicle-info-row" label="Assigned Driver">
                    <span class="assigned-drivers" [title]="getAssignedDriversLabel(vehicle)">
                        {{ getAssignedDriversLabel(vehicle) }}
                    </span>
                </xp-info-row>
            </div>

            <mat-card-actions class="operator-vehiclebtn" align="end">
                <ng-container *ngIf="getApprovalStatus(vehicle) === 'Pending'">
                    <button mat-stroked-button type="button" class="add-driver-btn" disabled>Add Drivers</button>
                    <button mat-flat-button color="primary" type="button" class="view-btn" disabled>View</button>
                </ng-container>
                <ng-container *ngIf="getApprovalStatus(vehicle) === 'Rejected'">
                    <button mat-stroked-button type="button" class="add-driver-btn" disabled>Add Drivers</button>
                    <button mat-flat-button color="primary" type="button" class="view-btn" (click)="openVehicleDetail(vehicle.Id)">View</button>
                </ng-container>
                <ng-container *ngIf="getApprovalStatus(vehicle) === 'Approved'">
                    <button mat-stroked-button type="button" class="add-driver-btn" (click)="openAddDriversDialog(vehicle.Id)">Add Drivers</button>
                    <button mat-flat-button color="primary" type="button" class="view-btn" (click)="openVehicleDetail(vehicle.Id)">View</button>
                </ng-container>
            </mat-card-actions>
        </mat-card>

        <mat-card class="operator-vehicle-add-block mb-5 mt-3">
            <div class="operator-vehicle-add-block__img">
                <img src="Content/xpress-app/images/operator/gray-car.png" alt="" />
            </div>
            <div class="flex flex-column align-items-center gap-3">
                <div class="add-vehicle-title">Add Vehicle</div>
                <button mat-flat-button color="primary" type="button" class="add-vehicle-btn" (click)="openAddOperatorVehicle()">
                    <mat-icon>add_circle_outline</mat-icon>
                    Add
                </button>
            </div>
        </mat-card>
    </div>
</div>
